import React, { useState, useEffect, useMemo } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import { Image } from "react-bootstrap";
import "../components/federado.css";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';

const API_URL = "https://facach.coop.hn/api";

const FALLBACK = [
  {
    id: 1, name: "Sistema Financiero",
    reports: [
      { id: 1, name: "Estados Financieros",     description: "Consulta los estados financieros.", cover_url: null, powerbi_url: "#" },
      { id: 2, name: "Préstamos",               description: "Indicadores de cartera de préstamos.", cover_url: null, powerbi_url: "#" },
      { id: 3, name: "Depósitos",               description: "Evolución de depósitos.", cover_url: null, powerbi_url: "#" },
      { id: 4, name: "Indicadores Financieros", description: "Indicadores clave del sector.", cover_url: null, powerbi_url: "#" },
    ],
  },
];

export default function SistemaFederado() {
  const { settings }      = useSiteSettings();
  const bannerSrc         = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;

  const [data, setData]           = useState(FALLBACK);
  const [loading, setLoading]     = useState(true);
  const [view, setView]           = useState('grid');
  const [search, setSearch]       = useState('');
  const [catFilter, setCatFilter] = useState('all');
  const [collapsed, setCollapsed] = useState({});

  useEffect(() => {
    const fetch_ = async () => {
      try {
        const res  = await fetch(`${API_URL}/federated`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data?.length > 0) setData(json.data);
      } catch (err) {
        console.error("Error cargando sistema federado:", err.message);
      } finally { setLoading(false); }
    };
    fetch_();
  }, []);

  const toggleCollapse = (id) =>
    setCollapsed(prev => ({ ...prev, [id]: !prev[id] }));

  const filtered = useMemo(() => {
    return data
      .filter(cat => catFilter === 'all' || String(cat.id) === catFilter)
      .map(cat => ({
        ...cat,
        reports: cat.reports.filter(r =>
          r.name.toLowerCase().includes(search.toLowerCase()) ||
          (r.description || '').toLowerCase().includes(search.toLowerCase())
        ),
      }))
      .filter(cat => cat.reports.length > 0);
  }, [data, search, catFilter]);

  return (
    <div className="federado-page">
      <NavbarFacach />

      {/* Banner dinámico desde el CMS */}
      <div className="banner-wrapper">
        <Image
          src={bannerSrc}
          alt="Sistema Federado FACACH"
          fluid
          className="banner-image"
        />
        <div className="banner-overlay">
          <h1 className="banner-title">SISTEMA FEDERADO FACACH</h1>
          <p className="banner-description">
            Accede a los tableros de información del sector cooperativo hondureño
          </p>
        </div>
      </div>

      {loading ? (
        <div className="federado-empty" style={{ paddingTop: 80 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>⏳</div>
          <div style={{ fontSize: 15, fontWeight: 600 }}>Cargando datos…</div>
        </div>
      ) : (
        <>
          {/* Filtros por categoría */}
          <div className="federado-filters">
            <button
              className={`federado-filter-btn ${catFilter === 'all' ? 'active' : ''}`}
              onClick={() => setCatFilter('all')}
            >Todos</button>
            {data.map(cat => (
              <button key={cat.id}
                className={`federado-filter-btn ${catFilter === String(cat.id) ? 'active' : ''}`}
                onClick={() => setCatFilter(String(cat.id))}
              >{cat.name}</button>
            ))}
          </div>

          {/* Búsqueda */}
          <div className="federado-search-wrap">
            <div style={{ position: "relative", width: "100%", maxWidth: 480 }}>
              <input
                className="federado-search"
                placeholder="Buscar reporte…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Toggle vista */}
          <div className="federado-view-toggle">
            <button className={`federado-view-btn ${view === 'grid' ? 'active' : ''}`}
              onClick={() => setView('grid')} title="Vista grilla">⊞</button>
            <button className={`federado-view-btn ${view === 'list' ? 'active' : ''}`}
              onClick={() => setView('list')} title="Vista lista">☰</button>
          </div>

          {/* Categorías con reportes */}
          {filtered.length === 0 ? (
            <div className="federado-empty">
              <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: "#1a3a6b" }}>Sin resultados</div>
              <div style={{ fontSize: 13, marginTop: 4 }}>Intenta con otro término de búsqueda</div>
            </div>
          ) : (
            filtered.map(cat => (
              <div key={cat.id} className="federado-category">
                <div className="federado-category-header" onClick={() => toggleCollapse(cat.id)}>
                  <div className="federado-category-title">

                    {cat.name}
                    <span style={{ fontSize: 12, color: "#7a8aaa", fontWeight: 500 }}>
                      ({cat.reports.length} {cat.reports.length === 1 ? 'reporte' : 'reportes'})
                    </span>
                  </div>
                  <span className={`federado-category-arrow ${!collapsed[cat.id] ? 'open' : ''}`}>▼</span>
                </div>

                {!collapsed[cat.id] && (
                  view === 'grid' ? (
                    <div className="federado-grid">
                      {cat.reports.map(r => (
                        <div key={r.id} className="federado-card"
                          onClick={() => window.open(r.powerbi_url, '_blank', 'noopener,noreferrer')}
                        >
                          {r.cover_url ? (
                            <img src={r.cover_url} alt={r.name} className="federado-card-img" />
                          ) : (
                            <div className="federado-card-img-placeholder">📊</div>
                          )}
                          <div className="federado-card-body">
                            <div className="federado-card-name">{r.name}</div>
                            {r.description && (
                              <div className="federado-card-desc">{r.description}</div>
                            )}
                          </div>
                          <div className="federado-card-footer">
                            {/* ── Enlace en lugar de botón ── */}
                            <a href={r.powerbi_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="federado-link"
                              onClick={e => e.stopPropagation()}
                            >
                              Ver reporte 
                            </a>
                              
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="federado-list">
                      {cat.reports.map(r => (
                        <div key={r.id} className="federado-list-item"
                          onClick={() => window.open(r.powerbi_url, '_blank', 'noopener,noreferrer')}
                        >
                          {r.cover_url ? (
                            <img src={r.cover_url} alt={r.name} className="federado-list-img" />
                          ) : (
                            <div className="federado-list-placeholder">📊</div>
                          )}
                          <div className="federado-list-name">{r.name}</div>
                          {r.description && (
                            <div style={{ fontSize: 12, color: "#7a8aaa", flex: 1 }}>{r.description}</div>
                          )}
                          {/* ── Enlace en lugar de botón ── */}
                          <a href={r.powerbi_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="federado-link"
                            onClick={e => e.stopPropagation()}
                          >
                            Ver reporte <span className="federado-link-arrow">→</span>
                          </a>
                            
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            ))
          )}
        </>
      )}

      <SocialBar position="right" top="35%" size={42} rounded={true} />
      <FooterFacach />
    </div>
  );
}